.my-products-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10010;

  &-bar {
    cursor: pointer;
    height: unset;
    justify-content: center;
    padding: unset;

    align-items: center;
    background-color: $svs-sunflower-yellow;
    box-sizing: border-box;
    color: $svs-black;
    display: flex;
    text-decoration: none;
    padding: 16px;
    @media (min-width: 781px) {
      cursor: unset;
      height: 70px;
      padding: 20px 0;
    }

    &-content {
      width: 51vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      @media (max-width: 780px) {
        width: 100%;
      }
    }

    &-text {
      flex-grow: 6;
    }

    &-link {
      flex-grow: 1;
      @media (max-width: 780px) {
        width: 100%;
        order: 1;
        margin-top: 12px;
      }

      &-btn {
        @media (max-width: 780px) {
          width: 100%;
        }
      }
    }
  }
}
